var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-alert',{attrs:{"type":"info"}},[_vm._v(" スカウト機能が無効になっています。"),_c('br'),_vm._v(" もしスカウト機能を使用する必要があった場合には、管理者の方へご確認ください。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }